<header>
  <div class="navbar navbar-expand-lg mb-4 fixed-top">
    <a class="navbar-brand" [href]="sharedDataSvc.pafEnvironment.logoUrl" target="_blank">
      <img [ngStyle]="sharedDataSvc.pafEnvironment.logoNgStyle" *ngIf="!sharedDataSvc.logoIsSvg" [src]="'./assets/images/'+sharedDataSvc.pafEnvironment.logo" />
      <svg-icon [ngStyle]="sharedDataSvc.pafEnvironment.logoNgStyle"  *ngIf="sharedDataSvc.logoIsSvg" [path]="'./assets/images/'+ sharedDataSvc.pafEnvironment.logo"></svg-icon>
    </a>
    <div class="collapse navbar-collapse" *ngIf="!!loggedUserInfo">
      <div class="navbar-nav">
        <a class="nav-link" routerLinkActive="active" routerLink="/suppliers" paflabel="Tableau_de_bord"></a>
      </div>
    </div>
    <div *ngIf="!!loggedUserInfo" class="navbar-title" style="flex-grow: 1;" paflabel="Portail_fournisseurs">
    </div>

    <ul class="navbar-nav" *ngIf="!!loggedUserInfo">
      <li class="nav-item">
        <app-lang-selector></app-lang-selector>
      </li>
      <li class="nav-item mx-1">
        <openid-logout></openid-logout>
      </li>
    </ul>
    <form *ngIf="sharedDataSvc.showDebugButton" class="form-inline small">
       <debug-toolbar></debug-toolbar>
    </form>
  </div>
</header>
<div class="container-fluid main-container">
  <router-outlet></router-outlet>
</div>
<footer>
  <div *ngIf="!!loggedUserInfo">
    <paflabel lblCod="Utilisateur_connecte"></paflabel> : {{loggedUserInfo.Contact?.Firstname}} {{loggedUserInfo.Contact?.Lastname}}
    ({{loggedUserInfo.Email}})
  </div>
</footer>